import { MapPin, Award, ShieldCheck, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function About() {
  return (
    <div data-testid="page-about">
      <section className="relative bg-gradient-to-br from-[#0F172A] via-[#1B3A6B] to-[#0F172A] py-20 lg:py-28 overflow-hidden">
        <div className="absolute inset-0 bg-grid opacity-20" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="text-xs uppercase tracking-[0.18em] font-semibold text-[#FBBF24] mb-4">À propos</div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight">
              INGélec, l'expertise locale au service de vos chantiers
            </h1>
            <p className="mt-6 text-lg text-slate-300 leading-relaxed">
              Micro-entreprise basée à Sainte-Suzanne, INGélec intervient sur toute l'île de La Réunion pour des prestations
              électrotechniques, de la location de matériel BTP et des études techniques en DAO.
            </p>
          </div>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="prose prose-slate max-w-none">
          <h2 className="font-display text-3xl font-bold text-slate-900 tracking-tight">Notre approche</h2>
          <p className="text-slate-600 leading-relaxed">
            Combinant expertise électrotechnique, qualification IRVE et savoir-faire en dessin technique, INGélec propose une offre intégrée
            pour les professionnels du BTP et les particuliers. Notre proximité géographique nous permet d'être réactifs sur l'ensemble du territoire réunionnais.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            { icon: Award, title: "Qualifié Qualifelec IRVE", desc: "Technicien IRVE Niveau 1 & 2 pour vos bornes de recharge." },
            { icon: ShieldCheck, title: "Conformité totale", desc: "Tous nos travaux respectent les normes EDF et électriques en vigueur." },
            { icon: MapPin, title: "Sainte-Suzanne · La Réunion", desc: "Basé au cœur de l'île, nous intervenons partout sans surcoût excessif." },
            { icon: Sparkles, title: "Service sur mesure", desc: "Devis personnalisé, conseil technique, accompagnement de A à Z." },
          ].map((v) => (
            <div key={v.title} className="rounded-2xl border border-slate-200 bg-white p-7" data-testid={`about-value-${v.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <div className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-[#1B3A6B]/5 text-[#1B3A6B] mb-4">
                <v.icon className="w-5 h-5" />
              </div>
              <h3 className="font-semibold text-slate-900">{v.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 rounded-2xl bg-[#1B3A6B] text-white p-10 text-center">
          <h3 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">Travaillons ensemble</h3>
          <p className="mt-3 text-slate-300">Contactez-nous pour discuter de votre projet — devis gratuit et sans engagement.</p>
          <Link to="/contact" className="inline-block mt-6">
            <Button className="bg-[#FBBF24] hover:bg-[#F59E0B] text-[#0F172A] font-semibold rounded-full px-7 h-11" data-testid="about-cta">Me contacter</Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
